import { zArr, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export const GetDocumentsArgs = zObj({ plantId: zNum(), assetId: zOptional(zNum()) });
export const PlantDocument = zObj({
    title: zStr(),
    date: zStr(),
    url: zStr(),
    asset: zOptional(zStr()),
});
export const PlantDocuments = zArr(PlantDocument);
//# sourceMappingURL=docs.js.map